<template>
  <a href="#" class="card text-white">
    <img src="/images/temp/promo_bg.png" class="card-img  d-none d-lg-block" alt="">
    <div class="card-img-overlay mobile-list">
      <div class="d-lg-block d-flex flex-row justify-content-between">
        <h2 class="card-title">
          <span>Wcześniej taniej!</span>
          10% - 30%
        </h2>
        <div class="btn btn-warning link d-none d-lg-block stretched-link">Więcej</div>
        <div class="btn btn-sm btn-primary link d-lg-none align-self-center btn-icon-arrow">
          <i class="bi bi-arrow-right mx-3"></i>
        </div>
      </div>
    </div>
  </a>
</template>
<script>

export default {
  name: 'offer-promo',
  components: {},
  data() {
    return {}
  }
}
</script>>